export var middlewareUserAuth = (to, from, next) => {
    let client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))

    if (!client_id) {
        next({name: 'user.login'})
    }
    next()
}

export var middlewareUserNotConnect = (to, from, next) => {
    let client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))

    if (client_id) {
        next({name: 'home'})
    }
    next()
}

export var middlewareUserHome = (to, from, next) => {
    let client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))

    if (!client_id) {
        next({name: 'welcome'})
    }
    next()
}



// WEBPACK FOOTER //
// ./src/companies/casino/router/Middlewares.js